<template>
  <div id="app">
    <audio controls="controls" hidden :src="sound" ref="audio" />
    <audio controls="controls" hidden :src="sound2" ref="audio2" />
    <router-view />
  </div>
</template>

<script>
import WebSocketClass from './common/websocket'
import sound from './assets/audio/auditAudio.mp3'
import sound2 from './assets/audio/auditAudio2.mp3'
import {getAuditPost} from "@/api/modules/recipe";
import {mapGetters} from "vuex";
export default {
  name: 'App',
  data() {
    return {
      sound:sound,
      sound2:sound2,
      webSocketClass: null,
      isShow: true,
      timer: null,
      videoSrc: '',
      loadingIntence: null,
      openJfyImg: true,
      times: null,
      allLoading: false
    }
  },
  methods: {
    // websock 通知
    getMessage(data) {
      console.log(data)
      let response = null
      if (data == 'PONG'){
        return;
      }
      if (data) {
        response = JSON.parse(data)
        if (response.type === 10) {
          let notify = this.$notify({
            message: '您有新的订单等待处理',
            type: 'warning',
            duration: 0,
            onClick: () => {
              this.$router.push({path: '/recipe/recipeList',})
              notify.close()
            }
          });
          this.$refs.audio.currentTime = 0;
          this.$refs.audio.play();
        }else if(response.type === 12){
          let notify = this.$notify({
            message: '您有新的处方审核等待处理',
            type: 'warning',
            duration: 0,
            onClick: () => {
              this.$router.push({path: '/recipe/RecipeAudit',})
              notify.close()
            }
          });
          getAuditPost({
            page:1,
            limit:999,
            checkStatus:0,
            storeId:this.storeInfo.storeId
          }).then(res=>{
            this.$store.dispatch('user/setRecipeNum', res.data.total)
          })
          this.$refs.audio2.currentTime = 0;
          this.$refs.audio2.play();
        } else {
          let responseData = ''
          if (response.data) responseData = JSON.parse(response.data)
          this.$notify.info(
            Object.assign({title: response.msg, duration: 5000}, responseData ? {message: responseData.msg} : {}))
        }
      }
    },
    wsSuccess() {
    },
    clearTimes() {
      clearTimeout(this.times)
      this.times = null
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
    ...mapGetters(['storeInfo'])
  },
  watch: {
    loadingState(state) {
      if (state) {
        this.allLoading = true
      } else {
        // this.allLoading = false
        this.times = setTimeout(() => {
          this.allLoading = false
          this.$nextTick(() => {
            this.clearTimes()
          })
        }, 500)
      }
    },

    token: {
      handler(val) {
        if (this.webSocketClass) {
          this.webSocketClass.closeMyself()
          this.webSocketClass = null
        }
        if (val) {


          // this.webSocketClass = new WebSocketClass(window.websocketUrl+`?token=${val}`, this.getMessage, this.wsSuccess)
          // this.webSocketClass.connect()


          let pro = ''
          if (window.location.protocol == 'https:' || window.location.protocol == 'HTTPS:'){
            pro = 'wss'
          }else {
            pro = 'ws'
          }
          // 云平台使用
          let url = pro + '://'+ window.location.host +'/' + pro
          // let url = 'ws://'+ window.location.host +'/ws'
          this.webSocketClass = new WebSocketClass(url+`?token=${val}`, this.getMessage, this.wsSuccess)
          this.webSocketClass.connect()

          // this.webSocketClass = new WebSocketClass(`${process.env.VUE_APP_BASEWEBSOCKETURL}?token=${val}`, this.getMessage, this.wsSuccess)

        }
      },
      immediate: true
    }
  },
}
</script>
